/* global femcare */

femcare.product.cart = {
    async init () {
        this.$cartModal = $('#cartModal');
        this.$stashModal = $('#stashModal');

        if (this.$cartModal.length) {
            this.$cartNotification = $('#cartNotificationModal');
            this.$items = this.$cartModal.find('.cart__items');
            this.antiforgeryToken = await femcare.form.protection.provideCSRFToken();
            this.refreshCartCount();
            this.initHandlers();
        }
    },

    getAntiforgeryToken () {
        return this.antiforgeryToken;
    },

    initHandlers () {
        this.initCartItemCountHandlers();
        this.initCartNotificationHandlers();

        $('.navigation-bar__icon--cart').on('click', (e) => this.openCart(e));
        $('.navigation-bar__icon--mobile-cart').on('click', (e) => this.openCart(e));

        femcare.shared.pubsub.subscribe('CART_ITEM_COUNT_UPDATED', (count) => {
            this.updateCartCounter(count);
        });
    },

    initCartItemCountHandlers () {
        // Handle quantity change
        this.$cartModal.on('countChanged', '.counter', (e, count, previousCount) => {
            const $counter = $(e.currentTarget);
            const skuId = $counter.closest('.cart-item').attr('data-sku-id');
            const skuEanId = $counter.closest('.cart-item').attr('data-ean-id');
            const index = $counter.closest('.cart-item').index();
            const difference = count - previousCount;
            const productInformation = { skuId, skuEanId, quantity: count, index, difference };

            if (difference > 0) {
                this.updateCartItemCount(productInformation, 'increment');
            } else if (difference < 0) {
                this.updateCartItemCount(productInformation, 'decrement');
            }
        });

        // Handle delete button
        this.$cartModal.on('click', '.cart-item__delete', (e) => {
            const $deleteBtn = $(e.currentTarget);
            const $cartItem = $deleteBtn.closest('.cart-item');
            const currentQuantity = $cartItem.find('.counter').counter('getCount');
            const index = $cartItem.index();

            femcare.tracking.product.ecommRemoveProductFromCart(this.currentCartData[index], currentQuantity);

            const productInformation = {
                skuId: $cartItem.attr('data-sku-id'),
                skuEanId: $cartItem.attr('data-ean-id'),
                quantity: 0,
                index,
                difference: 0
            };

            this.updateCartItemCount(productInformation, 'delete');
        });
    },

    updateCartItemCount (productInformation, changeType, onSuccessEndCallback) {

        const data = {
            ean: productInformation.skuEan,
            id: productInformation.skuId,
            quantity: productInformation.quantity
        };

        this.$cartModal.find('.cart__body').addClass('hidden');
        femcare.loader.toggleLoader(this.$cartModal[0], true);

        $.ajax({
            url: femcare.shared.util.baseUrl + 'ajax/products/product/updateBagItem',
            method: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(data),
            headers: { 'X-Request-Verification-Token': this.antiforgeryToken },
            success: (res) => {
                const contentData = typeof res.content === 'string' ? JSON.parse(res.content) : res.content;
                const order = contentData.order;
                const hasItems = res.success && order !== null;

                const cartItemCount = (order && order.totalItems) || 0;
                femcare.shared.pubsub.publish('CART_ITEM_COUNT_UPDATED', cartItemCount);
                this.$cartModal.find('.cart__body').removeClass('hidden');

                const modifiedRes = {
                    success: hasItems,
                    order
                };

                this.renderCart(modifiedRes);
                if (order && order.items && order.items[productInformation.index]) {
                    if (changeType === 'increment') {
                        femcare.tracking.product.ecommAddProductToCart(order.items[productInformation.index], productInformation.difference, false);
                    } else if (changeType === 'decrement') {
                        femcare.tracking.product.ecommRemoveProductFromCart(order.items[productInformation.index], productInformation.difference);
                    }
                }

                onSuccessEndCallback && onSuccessEndCallback();
            },
            complete: () => {
                this.$cartModal.find('.cart__body').removeClass('hidden');
                femcare.loader.toggleLoader(this.$cartModal[0], false);
            }
        });
    },

    initCartNotificationHandlers () {
        this.$cartNotification.find('.cart-notification-view__button').on('click', () => {
            this.openCart();
        });

        this.observeCartNotificationClose();

        $('.cart-notification-checkout__button').on('click', (e) => {
            // prevent default anchor tag behavior
            e.preventDefault();
            e.stopPropagation();

            $.ajax({
                url: `${femcare.shared.util.baseUrl}ajax/products/product/getbag`,
                dataType: 'json',
                method: 'GET',
                headers: { 'X-Request-Verification-Token': this.antiforgeryToken },
                success: (res) => {
                    const contentData = typeof res.content === 'string' ? JSON.parse(res.content) : res.content;
                    const order = contentData.order;
                    femcare.tracking.product.beginCheckoutAnalytics(order);
                    // continue with redirect to clicked link href attribute value
                    window.location.href = $(e.currentTarget).attr('href');
                }
            });
        });
    },

    openCart (e) {
        e && e.preventDefault();
        this.$cartModal.find('.cart__body').addClass('hidden');
        femcare.loader.toggleLoader(this.$cartModal[0], true);

        return $.ajax({
            url: femcare.shared.util.baseUrl + 'ajax/products/product/getbag',
            dataType: 'json',
            method: 'GET',
            headers: { 'X-Request-Verification-Token': this.antiforgeryToken },
            success: (res) => {
                const contentData = typeof res.content === 'string' ? JSON.parse(res.content) : res.content;
                const order = contentData.order;
                const hasItems = res.success && order !== null;

                const modifiedRes = {
                    success: hasItems,
                    order
                };

                this.$cartModal.find('.cart__body').removeClass('hidden');
                this.renderCart(modifiedRes);
                this.$cartNotification.removeClass('displayed');
                femcare.tracking.product.viewCartAnalytics(hasItems, order);

                $('.cart-checkout__button').on('click', () => {
                    femcare.tracking.product.beginCheckoutAnalytics(order);
                });

                this.currentCartData = order && order.items ? order.items : [];
            },
            complete: () => {
                femcare.loader.toggleLoader(this.$cartModal[0], false);
                this.$cartModal.find('.cart__body').removeClass('hidden');
            }
        });
    },

    displayAddedNotification (product, checkoutUrl) {
        this.$cartNotification.find('.cart-item__name').text(product.name);
        this.$cartNotification.find('.cart-item__skuName').text(product.productSkuName);
        this.$cartNotification.find('.cart-item__image').attr('src', product.images[0].url);
        this.$cartNotification.find('.cart-item__count').text(product.productQuantity.initial);
        this.$cartNotification.find('.cart-notification-checkout__button').attr('href', checkoutUrl);

        if (product.priceInformation.showDiscount) {
            this.$cartNotification.find('cart-item__original-price').text(product.priceInformation.priceWithoutDiscount);
            this.$cartNotification.find('cart-item__discounted-price').text(product.priceInformation.total);
        } else {
            this.$cartNotification.find('.cart-item__total').text(product.priceInformation.total);
        }
    },

    observeCartNotificationClose () {
        if (this.cartNotificationObserverAttached) {
            return;
        }

        const target = this.$cartNotification[0];
        if (!target) {
            return;
        }

        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (
                    mutation.attributeName === 'class' &&
                    !target.classList.contains('displayed')
                ) {
                    this.resetCartNotification();
                }
            });
        });

        observer.observe(target, { attributes: true, attributeFilter: ['class'] });
        this.cartNotificationObserverAttached = true;
    },

    resetCartNotification () {
        const $modal = this.$cartNotification;
        $modal.find('.cart-item__name').text('');
        $modal.find('.cart-item__skuName').text('');
        $modal.find('.cart-item__image').attr('src', '');
        $modal.find('.cart-item__count').text('');
        $modal.find('.cart-item__total').text('');
        $modal.find('.cart-item__original-price').text('');
        $modal.find('.cart-item__discounted-price').text('');
        $modal.find('.cart-suggested').empty();
    },

    refreshCartCount () {
        $.ajax({
            url: femcare.shared.util.baseUrl + 'ajax/products/product/getbag?onlyTotal',
            dataType: 'json',
            method: 'GET',
            headers: { 'X-Request-Verification-Token': this.antiforgeryToken },
            success (res) {
                const contentData = typeof res.content === 'string' ? JSON.parse(res.content) : res.content;
                const cartItemCount = (contentData && contentData.totalItems) || 0;
                femcare.shared.pubsub.publish('CART_ITEM_COUNT_UPDATED', cartItemCount);
            }
        });
    },

    renderCart (data) {
        const hasItems = data.success && data.order;

        if (hasItems) {
            this.$cartModal.find('.cart__body').removeClass('cart__body--empty');
            const order = data.order;
            const $itemList = this.$cartModal.find('.cart__items');
            $itemList.addClass('displayed');
            this.$cartModal.find('.cart-summary').addClass('displayed');
            $itemList.empty();

            order.items.forEach((item) => {
                const $item = $('<li class="cart-item"></li>');
                $item.attr('data-sku-name-complete', item.productSkuNameComplete);
                $item.attr('data-sku-name', item.productSkuName);
                $item.attr('data-sku-id', item.productSkuId);
                $item.attr('data-ean-id', item.productSkuEan);
                $item.attr('data-product-id', item.productId);
                $item.attr('data-selling-price', item.priceInformation.sellingPriceNoFormat);
                $item.attr('data-currency', item.priceInformation.currency.code);
                $item.attr('data-category', item.category);
                const $media = $('<div class="cart-item__media"></div>');
                const $image = $('<img class="cart-item__image"/>');
                $image.attr('src', item.images[0].url);
                $media.append($image);

                const $info = $('<div class="cart-item__info"></div>');
                const $name = $('<div class="cart-item__title"></div>');
                const $category = $('<div class="cart-item__name"></div>').text(item.name);
                const $skuName = $('<div class="cart-item__skuName"></div>').text(item.productSkuName);
                $name.append($category);
                $name.append($skuName);

                const $stock = $('<div class="cart-item__stock"></div>');
                const isInStock = item.productQuantity.max > 0 && item.productQuantity.available;

                const $message = $('<div class="cart-item__availability"></div>');
                $message.addClass('cart-item__availability--' + (isInStock ? 'in-stock' : 'out-of-stock'));
                $message.text(item.productQuantity.availability.stockMessage);
                $stock.append($message);

                if (isInStock) {
                    const $counterWrapper = $('<div class="cart-item__counter"></div>');
                    const $counter = $('<div class="counter" data-inputId="cartItemQuantity"></div>');
                    $counterWrapper.append($counter);
                    $stock.append($counterWrapper);
                    if (item.priceInformation.showDiscount) {
                        const $priceWrapper = $('<div class="cart-item__price-wrapper"></div>');

                        const $original = $('<div class="cart-item__original-price"></div>').text(item.priceInformation.priceWithoutDiscount);
                        const $discounted = $('<div class="cart-item__discounted-price"></div>').text(item.priceInformation.total);

                        $priceWrapper.append($original).append($discounted);
                        $stock.append($priceWrapper);
                    } else {
                        const $total = $('<div class="cart-item__total"></div>').text(item.priceInformation.total);
                        $stock.append($total);
                    }
                }

                $info.append($name);
                $info.append($stock);

                $stock.find('.counter').counter({
                    count: item.productQuantity.initial,
                    max: item.productQuantity.max
                });

                const $delete = $('<button class="cart-item__delete"><i class="icon-trash-can"></i></button>');
                $info.append($delete);
                $item.append($media);
                $item.append($info);
                $itemList.append($item);
            });

            let discount = null;
            let subtotal = null;

            order.totalizers.forEach((totalizer) => {
                if (totalizer.id === 'Items') {
                    subtotal = totalizer.value;
                } else if (totalizer.id === 'Discounts') {
                    discount = totalizer.value;
                }
            });

            const $discount = this.$cartModal.find('.cart-discount');
            const $discountCost = $discount.find('.cart-discount__cost');

            if (discount) {
                $discountCost.text(discount);
                $discount.show();
            } else {
                $discountCost.text('');
                $discount.hide();
            }

            this.$cartModal.find('.cart-subtotal__cost').text(subtotal);
            this.$cartModal.find('.cart-checkout__button').attr('href', data.order.checkoutUrl);
        } else {
            this.$cartModal.find('.cart__body').addClass('cart__body--empty');
            this.$cartModal.find('.cart__items').removeClass('displayed');
            this.$cartModal.find('.cart-summary').removeClass('displayed');
        }
    },

    updateCartCounter (count) {
        $('.navigation-bar__cart-counter').text(count || 0);
    }
};
